export enum BlogStatus {
  DRAFT = 'draft',
  PUBLISH = 'publish',
}
